const ADMIN_EXPORT_UNMAPPED_RECORDS = '/admin/mastering/export-unmapped-records'
const ADMIN_IMPORT_MAPPED_RECORDS = '/admin/mastering/import-mapped-records'
const ADMIN_MAP_SINGLE_RECORDS = '/admin/mastering/map-single-record'


export {
    ADMIN_EXPORT_UNMAPPED_RECORDS,
    ADMIN_IMPORT_MAPPED_RECORDS,
    ADMIN_MAP_SINGLE_RECORDS
}